var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help"},[_c('main-menu'),_c('v-app',{attrs:{"id":"inspire"}},[_c('h1',{staticClass:"notice"},[_vm._v("Notification")]),_c('v-container',[_c('v-card',{staticClass:"mx-auto",attrs:{"elevation":"12","height":"150","max-width":"500"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }